import { contractServiceClient } from '@lib/documentServiceClient';
import { createEditorService } from '@workpay/ds-shared/services/editorService';

export const dsEditorService = createEditorService(contractServiceClient);
